(function () {
  'use strict';

  var moduleSelector = '[data-new-customer-price]';
  var subscribedKey = 'bv_subscription_popup_subscribed_v1';
  var subscribedInMemory = false;

  function isSubscribed() {
    if (subscribedInMemory) {
      return true;
    }

    try {
      return window.localStorage.getItem(subscribedKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function setModuleVisibility(module, visible) {
    if (!module) {
      return;
    }

    module.hidden = !visible;
    if (visible) {
      module.removeAttribute('aria-hidden');
    } else {
      module.setAttribute('aria-hidden', 'true');
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(moduleSelector), function (module) {
      setModuleVisibility(module, !isSubscribed());
    });
  }

  document.addEventListener('bv:subscription:success', function () {
    subscribedInMemory = true;
    Array.prototype.forEach.call(document.querySelectorAll(moduleSelector), function (module) {
      setModuleVisibility(module, false);
    });
  });

  window.addEventListener('storage', function (event) {
    if (!event || event.newValue !== '1' || event.key !== subscribedKey) {
      return;
    }

    Array.prototype.forEach.call(document.querySelectorAll(moduleSelector), function (module) {
      setModuleVisibility(module, false);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
